import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";
import { SectionTitle } from "./ui";
import { http } from "@/lib/site";

export const Testimonials = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    http.get("/testimonials").then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => setItems([]));
  }, []);
  if (!items.length) return null;

  return (
    <section id="testimonios" data-testid="testimonials-section" className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Reveal><SectionTitle title="Lo que dicen quienes ya conversaron con nosotros" /></Reveal>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {items.map((t, i) => (
            <Reveal key={t.id} delay={(i % 3) * 0.06} className="h-full">
              <figure className="flex h-full flex-col rounded-2xl border border-[#E3EAEF] bg-[#F4F7F9] p-6" data-testid={`testimonial-${t.id}`}>
                <Quote className="h-7 w-7 text-[#13766C]" aria-hidden="true" />
                <blockquote className="mt-4 flex-1 text-[18px] leading-relaxed text-[#1F2A33]">“{t.texto}”</blockquote>
                <figcaption className="mt-5 text-[16px] font-bold text-[#0B3C5D]">
                  {t.nombre}{t.comuna && <span className="font-medium text-[#4A5864]"> · {t.comuna}</span>}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
